var  variantidflas=false;
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
            var myselect = document.querySelector('[dataset="Option-section-0"]');
        //  var myselect=document.getElementById('Option-template--21953404961086__main-0');
            var mynewselect= document.querySelector('.select-new .product-form__input--dropdown');
            var cartflag=false;    

 if(mynewselect!=null)
 {
            var myproductinfo = document.getElementById('myproduct-info');
           if (myproductinfo.classList.contains('hilineboxab')) {
              var  hilineboxflag=1;
               var  cartflag=true;
             } else { var hilineboxflag=2; var  cartflag=false;}

     if(hilineboxflag==2){
       var myproductinfo = document.getElementById('myproduct-info');
           if (myproductinfo.classList.contains('hilineboxabs')) {
           
              var  hilineboxflag=1;
               var  cartflag=true;
              }

 }
      if(cartflag==false)
          {
                this.handleErrorMessage('Please select from the options above.');  //+text
                 document.querySelector('html').classList.add('noscroll');
                 document.querySelector('.product__info-wrapper').classList.add('hilinebox');
                 document.querySelector('.product__info-wrapper').classList.add('hilineboxab');
                 document.querySelector('.product-form__error-message-wrapper').classList.add('tipstop');
                cartflag=true;
                return false; 
          }

         if(cartflag==true)
          {      
            if(hilineboxflag==2 )
             { 
                 this.handleErrorMessage('Please select from the options above.');  //+text
                 document.querySelector('html').classList.add('noscroll');
                 document.querySelector('.product__info-wrapper').classList.add('hilinebox');
                 document.querySelector('.product__info-wrapper').classList.add('hilineboxab');
                 document.querySelector('.product-form__error-message-wrapper').classList.add('tipstop');
                 console.log(hilineboxflag+"rrt");
                 return false; 
             }
       console.log(hilineboxflag+"df");
          }
        }
    document.querySelector('.product__info-wrapper').classList.remove('hilineboxab');   
  document.querySelector('.product__info-wrapper').classList.remove('hilineboxabs');   
  

     //   return false;
        if(myselect!=null)
        {
        var index=myselect.selectedIndex ;
        var optionid =  myselect.options[index].value;
        var formDatavp = new FormData(this.form);
           formDatavp.append('sections_url', window.location.pathname);
        var responseid=   formDatavp.get('id');
        var variantid=  this.handlegetQueryString('variant');
           
        if(variantid=="1abc")
          {
               if(variantidflas==false)
               {
              //   console.log(variantidflas+"bac");  
                // variantidflas=true;
               //  var element = document.querySelector('.product-form__input--dropdown .form__label');
               //  var text = element.textContent;
                // this.handleErrorMessage('Please select from the options above');  //+text
                // document.querySelector('html').classList.add('noscroll');
                // document.querySelector('.product__info-wrapper').classList.add('hilinebox');
               //  document.querySelector('.product-form__error-message-wrapper').classList.add('tipstop');
               //  return false; 
               }
          }
        }
          document.querySelector('html').classList.remove('noscroll');
          document.querySelector('.product__info-wrapper').classList.remove('hilinebox');
          document.querySelector('.product-form__error-message-wrapper').classList.remove('tipstop');
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    const selectedIds = [];
                    Array.from(document.querySelectorAll('._hid_checkbox:checked')).forEach((cb) => selectedIds.push(cb.value));
                    Array.from(document.querySelectorAll('._input_selectBox')).forEach((sel) => { if (sel.value && sel.value !== '-1') selectedIds.push(sel.value); });
                    if (selectedIds.length) addItemsSequential(selectedIds, this.cart);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              // Check if upsell popup is enabled
              const upsellPopupEnabled = window.upsellPopup && document.getElementById('upsell-popup-overlay');
              
              if (upsellPopupEnabled) {
                console.log('[UPSELL] Opening upsell popup instead of cart notification');
                
                // Update cart count in popup data
                if (window.upsellPopup.productData) {
                  window.upsellPopup.productData.cartCount = response.item_count || (window.upsellPopup.productData.cartCount + 1);
                }
                
                // Open upsell popup
                window.upsellPopup.open();
                
                // Still collect and add selected upsell items from product page
                // Checkboxes removed, logic simplified/removed
                /*
                const selectedIds = [];
                const singleCheckboxes = document.querySelectorAll('._hid_checkbox:checked');
                Array.from(singleCheckboxes).forEach((cb) => {
                  selectedIds.push(cb.value);
                });
                
                const multiCheckboxes = document.querySelectorAll('._hid_checkbox_multi:checked');
                Array.from(multiCheckboxes).forEach((cb) => {
                  if (cb.value && cb.value !== '') {
                    selectedIds.push(cb.value);
                  }
                });
                
                if (selectedIds.length) {
                  addItemsSequential(selectedIds, this.cart);
                }
                */
              } else {
                // Default behavior - show cart notification
                this.cart.renderContents(response);
                
                console.log('[UPSELL DEBUG] Main product added, now checking for upsell items...');
                
                // Collect selected upsell items
                // Checkboxes removed, so we don't automatically add upsells with main product anymore
                // Users must click the individual "+" buttons for upsell items
                
                /*
                const selectedIds = [];
                
                // Get checkboxes for single variant products
                const singleCheckboxes = document.querySelectorAll('._hid_checkbox:checked');
                console.log('[UPSELL DEBUG] Single variant checked checkboxes:', singleCheckboxes.length);
                Array.from(singleCheckboxes).forEach((cb) => {
                  console.log('[UPSELL DEBUG] Adding single variant id:', cb.value);
                  selectedIds.push(cb.value);
                });
                
                // Get selected variants from dropdowns for multi-variant products (only if checkbox is checked)
                const multiCheckboxes = document.querySelectorAll('._hid_checkbox_multi:checked');
                console.log('[UPSELL DEBUG] Multi variant checked checkboxes:', multiCheckboxes.length);
                Array.from(multiCheckboxes).forEach((cb) => {
                  if (cb.value && cb.value !== '') {
                    console.log('[UPSELL DEBUG] Adding multi variant id from checkbox:', cb.value);
                    selectedIds.push(cb.value);
                  }
                });
                
                console.log('[UPSELL DEBUG] Total upsell items to add:', selectedIds.length);
                console.log('[UPSELL DEBUG] Upsell variant IDs:', selectedIds);
                
                // Add all selected upsell items to cart
                if (selectedIds.length) {
                  addItemsSequential(selectedIds, this.cart);
                }
                */
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handlegetQueryString(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return decodeURIComponent(r[2]);
        };
        return "1abc";
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
document.getElementById('closeSelectmodal').addEventListener('click', function() {
  document.querySelector('html').classList.remove('noscroll');
  document.querySelector('.product__info-wrapper').classList.remove('hilinebox');
  document.querySelector('.product-form__error-message-wrapper').classList.remove('tipstop');
  document.querySelector('.product-form__error-message-wrapper').setAttribute('hidden',true);
});
function addItemsToCart(items, cartInstance) {
  const body = { items };
  if (cartInstance) {
    body.sections = cartInstance.getSectionsToRender().map((s) => s.id);
    body.sections_url = window.location.pathname;
    cartInstance.setActiveElement(document.activeElement);
  }
  const addUrl = (typeof routes !== 'undefined' && routes.cart_add_url)
    ? (routes.cart_add_url.endsWith('.js') ? routes.cart_add_url : `${routes.cart_add_url}.js`)
    : '/cart/add.js';
  const config = fetchConfig('json');
  config.headers['Content-Type'] = 'application/json';
  config.body = JSON.stringify(body);
  return fetch(addUrl, config).then((r) => r.json());
}
function addItemToCartForm(id, cartInstance) {
  console.log('[UPSELL DEBUG] addItemToCartForm called with id:', id);
  console.log('[UPSELL DEBUG] cartInstance:', cartInstance ? 'exists' : 'null');
  
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  const formData = new FormData();
  formData.append('id', id);
  formData.append('quantity', 1);
  
  if (cartInstance) {
    formData.append('sections', cartInstance.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
    cartInstance.setActiveElement(document.activeElement);
  }
  config.body = formData;
  
  const addUrl = (typeof routes !== 'undefined' && routes.cart_add_url) ? routes.cart_add_url : '/cart/add';
  console.log('[UPSELL DEBUG] Cart add URL:', addUrl);
  console.log('[UPSELL DEBUG] FormData id:', formData.get('id'));
  
  return fetch(addUrl, config)
    .then((r) => {
      console.log('[UPSELL DEBUG] Fetch response status:', r.status);
      return r.json();
    })
    .then((data) => {
      console.log('[UPSELL DEBUG] Response data:', data);
      return data;
    });
}
function addItemsSequential(ids, cartInstance) {
  console.log('[UPSELL DEBUG] addItemsSequential called with ids:', ids);
  let chain = Promise.resolve();
  ids.forEach((id, index) => {
    chain = chain.then(() => {
      console.log(`[UPSELL DEBUG] Adding item ${index + 1}/${ids.length}: ${id}`);
      return addItemToCartForm(id, cartInstance).then((response) => {
        console.log(`[UPSELL DEBUG] Item ${id} add response:`, response);
        if (response.status) {
          console.error(`[UPSELL DEBUG] Error adding item ${id}:`, response.description || response.message);
        } else if (cartInstance) {
          cartInstance.renderContents(response);
        }
        return response;
      });
    });
  });
  return chain;
}
// Handle upsell "+" button clicks
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.upsell__add');
  if (!btn) return;
  
  e.preventDefault();
  e.stopPropagation();
  
  // Find the parent container
  const container = btn.closest('.parent_cart');
  if (!container) return;
  
  // Try to get variant ID from button data attribute (single variant products)
  let variantId = btn.dataset.variantId || null;
  
  // If no variant ID on button, check for select dropdown (multi-variant products)
  if (!variantId) {
    const select = container.querySelector('._input_selectBox');
    if (select) {
      if (select.value && select.value !== '-1') {
        variantId = select.value;
      } else {
        // Show error - user must select an option first
        alert('Please select an option before adding to cart.');
        return;
      }
    }
  }
  
  if (!variantId) {
    console.error('No variant ID found for upsell item');
    return;
  }
  
  // Set flag to prevent recommended products popup from showing
  window.__skipUpsellPopup = true;
  // Set flag to show cart-notification-product instead of upsell
  window.__showCartNotificationProduct = true;
  
  // Disable button to prevent double clicks
  btn.disabled = true;
  btn.textContent = '✓';
  
  // Get cart instance
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  
  // Add item to cart
  addItemToCartForm(variantId, cart)
    .then((response) => {
      if (response.status) {
        // Error occurred
        alert(response.description || 'Could not add item to cart');
        btn.disabled = false;
        btn.textContent = '+';
        window.__skipUpsellPopup = false;
        window.__showCartNotificationProduct = false;
      } else {
        // Success - don't show cart-notification, only show notification message
        // Update cart count manually
        const cartBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span, .cart-count, [data-cart-count]');
        if (cartBubble && response.item_count !== undefined) {
          cartBubble.textContent = response.item_count;
        }
        
        // Show notification message instead of cart-notification popup
        if (window.upsellPopup && window.upsellPopup.showNotification) {
          window.upsellPopup.showNotification(window.upsellPopup.settings.messages.addedToCart, 'success');
        }
        
        // Keep checkmark for 2 seconds then reset
        setTimeout(() => {
          btn.disabled = false;
          btn.textContent = '+';
          window.__skipUpsellPopup = false;
          window.__showCartNotificationProduct = false;
        }, 2000);
      }
    })
    .catch((e) => {
      console.error('Error adding upsell item:', e);
      alert('Error adding item to cart');
      btn.disabled = false;
      btn.textContent = '+';
      window.__skipUpsellPopup = false;
      window.__showCartNotificationProduct = false;
    });
});

// Handle dropdown changes for multi-variant upsell products
// Simplified: no longer managing checkbox state
document.addEventListener('change', (e) => {
  if (e.target.classList.contains('_input_selectBox')) {
    const select = e.target;
    const container = select.closest('.parent_cart');
    if (!container) return;
    
    // Update price display if needed
    const selectedOption = select.options[select.selectedIndex];
    const priceData = selectedOption.getAttribute('price_data');
    if (priceData) {
      const priceElement = container.querySelector('._price_data');
      if (priceElement) {
        priceElement.textContent = priceData;
      }
    }
  }
});
